import { render, staticRenderFns } from "./ProfessionsList.vue?vue&type=template&id=0a1698fb&scoped=true&"
import script from "./ProfessionsList.vue?vue&type=script&lang=js&"
export * from "./ProfessionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1698fb",
  null
  
)

export default component.exports